import { IntegrationsIcon } from '@rsos/base-assets/icons';
import { conversationStateValues } from '@rsos/reduxDataStore/src/features/conversations/conversations.typings';
import styled from '@rsos/theme/styled';

const BannerContainer = styled.div`
  display: flex;
  padding: 8px 20px;
  border-radius: 5px;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  background-color: ${({ theme }) => theme.colors.lightWarning};
  margin: 16px 0;
`;

const BannerText = styled.span`
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.lightWarningText};
`;

interface TransferPendingBannerProps {
  conversation: conversationStateValues | undefined;
}

function TransferPendingBanner({ conversation }: TransferPendingBannerProps) {
  if (conversation?.transfer?.status !== 'pending') {
    return null;
  }

  const agencyLabel =
    conversation.transfer.receivingAgencyName ?? 'receiving agency';

  return (
    <BannerContainer>
      <IntegrationsIcon width={14} height={14} color="lightWarningText" />
      <BannerText>Waiting for {agencyLabel} to connect...</BannerText>
    </BannerContainer>
  );
}

export default TransferPendingBanner;
